import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

import Flex from '~/common/components/Flex';
import InputLabel from '~/common/components/InputLabel';
import ListItemText from '~/common/components/Lists/ListItemText';
import MenuItem from '~/common/components/Menus/MenuItem';
import FormControl from '~/common/mui/Inputs/Forms/FormControl/FormControl';
import EnhancedSelect from '~/common/mui/Inputs/Selects/EnhancedSelect';

const findValue = (
  value: string,
  options: CrudGridFilterProps['filter']['options'],
) => options.find((option) => option.value === value).label;

type CrudGridFilterProps = {
  filter?: {
    label?: string;
    options?: {
      label?: string;
      value?: string;
    }[];
  };
  currentFilter?: any[];
  handleFilterChange?: (...args: any[]) => any;
};

export default function CrudGridFilter({
  filter,
  currentFilter,
  handleFilterChange,
}: Readonly<CrudGridFilterProps>) {
  return (
    <Flex width={'15rem'}>
      <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }} fullWidth>
        <InputLabel id="demo-multiple-checkbox-label">
          {filter.label}
        </InputLabel>
        <EnhancedSelect
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          isMultiple={true}
          value={currentFilter}
          label={filter.label}
          onChange={(e) => {
            handleFilterChange(filter, e.target.value);
          }}
          renderValue={(selected) =>
            selected.map((value) => findValue(value, filter.options)).join(', ')
          }
        >
          {filter.options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              <span
                aria-hidden="true"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  marginRight: '8px',
                  verticalAlign: 'middle',
                }}
              >
                {currentFilter.includes(option.value) ? (
                  <CheckBoxIcon fontSize="small" />
                ) : (
                  <CheckBoxOutlineBlankIcon fontSize="small" />
                )}
              </span>
              <ListItemText primary={option.label} />
            </MenuItem>
          ))}
        </EnhancedSelect>
      </FormControl>
    </Flex>
  );
}
